module.exports = __webpack_public_path__ + "img/btn_next-track.36e574db.svg";